<script setup>
import MainHeader from "@/Components/MainHeader.vue";
import MainFooter from "@/Components/MainFooter.vue";
import EnergyConfirmationModal from "@/Components/GenerationForms/EnergyConfirmationModal.vue";
import GenerationIndicator from "@/Components/GenerationIndicator.vue";
import {useEnergyConfirmationStore} from "@/Stores/energyConfirmationStore";
import SystemMessageBanner from "@/Components/Validation/SystemMessageBanner.vue";

const energyConfirmationStore = useEnergyConfirmationStore();

</script>

<template>
    <div class="min-h-screen bg-slate-800 flex flex-col">
        <nav>
            <MainHeader/>
            <SystemMessageBanner/>
            <EnergyConfirmationModal :show="energyConfirmationStore.displayModal" @close="energyConfirmationStore.displayModal = false"/>
        </nav>
        <div class="w-full mt-1 shadow-md overflow-hidden md:border-0 border-t border-gray-500 flex-grow">
            <slot/>
        </div>
        <MainFooter/>

        <!-- Generation Task Indicator -->
        <GenerationIndicator/>
    </div>
</template>
